import React from "react";
import coverImage from "../../../../media/images/headCover.svg";
import { Box, Typography, useTheme } from "@mui/material";
import bannerImage from "../../../../media/images/courseCover.png";
import { Link } from "react-router-dom";
import StickyNoteIcon from "../../../../media/images/icons/sticky-note";
import ArrowLeftSVG from "../../../../media/images/icons/arrow-left";
export default function SingleCourse() {
  const theme = useTheme();

  return (
    <>
      <Box
        sx={{
          backgroundImage: `
          linear-gradient(0deg, rgba(211, 134, 39, 0.97) 46.43%, rgba(239, 183, 114, 0.81) 135.27%),
            url(${coverImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: "column",
          borderRadius: "20px",
          justifyContent: "end",
          paddingX: "16px",
          boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.20)",
        }}
      >
        <Typography
          sx={{
            marginTop: "60px",
            fontSize: "22px",
            fontWeight: "900",
            color: "background.default",
          }}
        >
          آموزش ویدئویی{" "}
        </Typography>
        <Typography
          sx={{
            marginBottom: "16px",
            color: "background.default",
          }}
        >
          ایجاد سفارش بار جدید{" "}
        </Typography>
      </Box>
      <Box
        sx={{
          marginTop: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <img width={"100%"} src={bannerImage} alt="" />
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 600,
            }}
          >
            در این ویدئوی آموزشی درباره روش های امتیاز گیری در باشگاه مشتریان
            توضیح داده ایم...{" "}
          </Typography>
        </Box>
        <Box
          sx={{
            backgroundColor: "background.default",
            boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.10)",
            padding: "16px",
            marginTop: "16px",
            borderRadius: "12px",
          }}
        >
          <Typography>
            اگر در بارگیری ویدئو مشکلی دارید یا اینترنت شما ضعیف است می‌توانید{" "}
            <Typography
              sx={{
                color: "secondary.main",
              }}
              component={"span"}
            >
              محتوای متنی+تصاویر{" "}
            </Typography>
            را که از همین آموزش است در بخش راهنمای بازارگاه مطالعه کنید.{" "}
          </Typography>
          <Link
            to={"#"}
            style={{
              marginTop: "16px",
              borderWidth: "1px",
              borderStyle: "solid",
              borderColor: theme.palette.secondary.dark,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "8px",
              borderRadius: "10px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <StickyNoteIcon color={theme.palette.secondary.dark} />
              <Typography
                sx={{
                  color: "secondary.dark",
                }}
              >
                مشاهده راهنمای متنی+تصاویر
              </Typography>
            </Box>

            <ArrowLeftSVG color={theme.palette.secondary.dark} />
          </Link>
        </Box>
      </Box>
    </>
  );
}
